<template>
  <div class="submit-order">
    <!-- 商品列表 -->
    <van-cell-group class="goods-info">
      <van-cell title="单元格" value="内容">
        <template #title>
          <van-image :src="mainOrder.goodImage">
            <!-- 图标加载失败 -->
            <template #error>
              <van-icon name="photo-o" />
            </template>
          </van-image>
        </template>
        <template #default>
          <p>
            商品名称 <span>{{ mainOrder.goodsName }}</span>
          </p>
          <p class="block">
            商品单价 <span v-html="mainOrder.price">周一至周五 ￥1.80 <br />周六、周日、法定节日 ￥0.60</span>
          </p>
        </template>
      </van-cell>
    </van-cell-group>
    <!-- 日期列表操作 零售 -->
    <template v-if="typeId == 4 && $store.state.newsKiosk.dateList.length">
      <van-cell value="购买日期及数量" class="list-block-margin" />
      <van-swipe-cell v-for="(item, index) in $store.state.newsKiosk.dateList" :key="index">
        <van-cell :border="false" :title="item.date" value="">
          <template>
            <van-stepper v-model="item.number" :min="$store.state.newsKiosk.dateList.length < 2 ? 1 : 0" :disable-plus="item.number >= item.stockNum" integer @change="changeNumber(item)" />
          </template>
        </van-cell>
        <template #right>
          <van-button square type="danger" text="删除" @click="deleDate(item)" />
        </template>
      </van-swipe-cell>
    </template>
    <!-- 购买数量 非零售 -->
    <van-cell v-if="typeId != 4" title="购买数量" value="购买数量" class="list-block-margin">
      <template>
        <van-stepper v-model="goodsNumber" :disabled="typeId === 1" />
      </template>
    </van-cell>
    <!-- 配送、发票等信息 -->
    <van-cell-group class="list-block-margin">
      <van-form ref="form" @submit="submitOrder">
        <van-cell title="配送方式" :value="getDelivertype" is-link @click="chooseDistributionMode" />
        <template v-if="typeId !== 1">
          <van-cell title="发票信息" :value="getInvoice" is-link @click="openInvoiceModal" />
        </template>
        <van-field
          v-model="formData.cardid"
          v-if="typeId === 1"
          name="cardid"
          label="报卡编号"
          placeholder="必填"
          :rules="[{ validator: valiDateCardId, message: '请输入报卡编号', trigger: 'onBlur' }]"
        />
        <van-field v-model="formData.requirement" rows="2" autosize label="订单备注" type="textarea" maxlength="10" placeholder="无" show-word-limit :rules="[{ validator: validateInput }]" />
      </van-form>
    </van-cell-group>
    <!-- 商品价格、快递费 列表  零售-->
    <van-cell-group class="price-list list-block-margin">
      <van-cell title="商品价格" value="2021-06-03 ￥14.40">
        <template v-if="typeId === 4">
          <div class="list-block-inset" v-for="date in $store.state.newsKiosk.dateList" :key="date.subOrderId">
            <p class="goods-price">
              <span>{{ date.date }}<strong style="color: #ff5757" v-if="moment(date.date).valueOf() > moment().valueOf()">预售</strong></span> ￥{{ date.price }}
            </p>
            <p class="count-price">￥{{ date.price }}x{{ date.number }}</p>
          </div>
        </template>
        <template v-else>
          {{ total.price }}
        </template>
      </van-cell>
      <van-cell :title="typeId !== 1 ? '快递费' : ''" value="不开发票">
        <template>
          <div class="list-block-inset">
            <p v-if="typeId === 4">￥{{ total.deliveryPrice }}</p>
            <p v-else>&nbsp;</p>
            <p class="total">
              共{{ total.count }}件 <span>总计 ￥{{ total.price }}</span>
            </p>
          </div>
        </template>
      </van-cell>
      <!-- 提示 -->
      <div class="notice" v-if="typeId !== 1">提交说明：商品一旦支付，不支持退款操作</div>
    </van-cell-group>
    <!-- 提交订单按钮 -->
    <van-button class="list-block-margin" type="primary" :loading="submitLoading" block loading-text="提交中" @click="checkUserSubscribe">提交订单</van-button>
    <!-- 取消订阅按钮 -->
    <van-button class="list-block-margin cancel-button" v-if="typeId === 4" block @click="cancelOrderRetailGoods">取消</van-button>
    <!-- 配送方式弹窗 -->
    <DistributionModal v-model="distributionInfo.show" :info="distributionInfo.info" @confirmInfo="getDisstributionInfo"></DistributionModal>
    <!-- 发票信息弹窗 -->
    <InvoiceModal v-model="invoiceModalInfo.show" :info="invoiceModalInfo.info" @confirmInfo="getInvoiceInfo"></InvoiceModal>
  </div>
</template>

<script>
  // 混入文件
  import { submitOrder } from '@/mixins/newsKiosk/submitOrder'
  export default {
    mixins: [submitOrder],
    data() {
      return {
        delivertype: 1, //配送方式类型选择
        papertype: 0, //发票信息类型选择
        papertypeInfo: {}, //发票信息填写
        formData: {},
        mainOrder: {}, //商品信息
        dateList: [], //订约日期及数量
        typeId: 0, //区分零售非零售
        goodsId: 0, //商品id
        goodsNumber: 0, // 非零售的商品数量
        orderId: ''
      }
    },
    created() {
      /**
       * todo 统一塞值处理
       */
      const setInfo = (res) => {
        let { mainOrder, subOrders, goodsInfo } = res
        let { price, priceHoliday, countStep, freight, freightMore, typeId, id } = goodsInfo
        this.typeId = typeId
        this.goodsId = id
        this.delivertype = this.typeId === 1 ? 0 : 1
        this.mainOrder = {
          ...mainOrder,
          goodImage: goodsInfo.picPath,
          price: priceHoliday && JSON.parse(priceHoliday) ? `周一至周五 ￥${price} <br />周六、周日、法定节假日 ￥${priceHoliday}` : `￥${price}`,
          countStep,
          freight,
          freightMore
        }
        this.$store.dispatch(
          'newsKiosk/updateActionDateList',
          subOrders.map((item) => ({ ...item, price: Number.parseFloat(item.price).toFixed(2), number: item.goodsNumber, disableMinus: false, date: item.saleDate.split(' ')[0] }))
        )
      }

      // 非零售
      let { typeId, goodsName, price, goodsId, goodsNumber, goodImage } = this.$route.query
      if (typeId && Number.parseInt(typeId) !== 4) {
        this.typeId = Number.parseInt(typeId)
        this.goodsId = Number.parseInt(goodsId)
        this.delivertype = this.goodsId === 314 ? 3 : this.typeId === 1 ? 0 : 1 //配送方式
        //商品信息
        this.mainOrder = {
          goodsName,
          price: `￥${price}`,
          goodImage
        }
        this.goodsNumber = this.typeId === 1 ? 1 : goodsNumber || 1 //购买数量
        return
      }

      // 零售
      this.getRetailGoodsOrderInfo().then((res) => {
        setInfo(res)
      })
    }
  }
</script>

<style lang="scss" scoped>
  .submit-order {
    .list-block-margin {
      margin-top: 10px;
    }
    // 重写cell布局 需求
    .van-cell__title,
    /deep/ .van-field__word-limit,
    /deep/ .van-field__label,
    .van-cell__value {
      color: #000;
    }
    .goods-info {
      .van-cell {
        align-items: flex-start;
        font-size: 3vw;
      }
      .van-cell__title {
        min-width: auto;
        flex: inherit;
        box-shadow: 0 0px 3px #ccc;
        text-align: center;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px;
        /deep/ .van-image {
          width: 20vw;
          height: 20vw;
          .van-image__error,
          .van-image__loading {
            font-size: 3rem;
            background-color: transparent;
          }
        }
      }
      .van-cell__value {
        text-align: left;
        flex: 1.5;
        p {
          margin: 0;
          line-height: 2;
          display: flex;
          span {
            flex: 1;
            margin-left: 6px;
          }
        }
      }
    }
    .price-list {
      .van-cell__value {
        flex: 1.5;
        .list-block-inset {
          margin-bottom: 10px;
        }
        p {
          margin: 0;

          &.total {
            color: #000;
            span {
              font-size: 4vw;
              color: #000;
            }
          }
          &.count-price {
            color: #000;
          }
          &.goods-price {
            display: flex;
            justify-content: flex-end;
            span {
              display: inline-block;
              flex: 1;
              text-align: left;
              strong {
                margin-left: 1rem;
                font-size: 0.5rem;
                font-weight: normal;
              }
            }
          }
        }
      }
    }
    .notice {
      background: #fff4f4;
      color: #ff5757;
      padding: 10px;
      text-align: center;
      font-size: 3vw;
    }
    .van-button {
      width: 90%;
      margin: 1vh auto;
      font-size: 1rem;
      height: auto;
      line-height: 2.5;
      &.van-button--danger {
        width: 100%;
      }
      &.cancel-button {
        background-color: #aaa;
        color: #fff;
      }
    }
    .van-swipe-cell__right {
      .van-button {
        margin: 0;
        height: 100%;
      }
    }
    /deep/ .van-popup {
      h2 {
        padding: 0 4vw;
        font-size: 5vw;
      }
    }
  }

  @media screen and (min-width: 768px) {
    .submit-order {
      .goods-info .van-cell {
        font-size: 26px;
      }

      .notice,
      .van-button,
      .van-cell {
        font-size: 16px !important;
      }

      /deep/ .van-popup {
        h2 {
          padding: 0 16px;
          font-size: 16px;
        }
        .van-button {
          margin-top: 30px;
        }
      }

      .price-list .van-cell__value p.total span {
        font-size: 18px;
      }
    }
  }
</style>
